export default "__VITE_ASSET__CtLJ749d__"